import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-primary/10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-sm bg-primary flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-xl font-serif">A</span>
              </div>
              <span className="text-foreground font-serif text-xl tracking-tight">
                Artisan Pizza <span className="text-primary">Talent</span>
              </span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
              {t.footer.tagline}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="mailto:giacomo@artisanpizzatalent.com"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                data-testid="footer-email"
              >
                <Mail size={16} />
                giacomo@artisanpizzatalent.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-foreground font-serif text-lg mb-4">{t.footer.quickLinks}</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                {t.nav.home}
              </Link>
              <Link to="/per-pizzaioli" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                {t.nav.forChefs}
              </Link>
              <Link to="/per-ristoratori" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                {t.nav.forRestaurants}
              </Link>
              <Link to="/chi-siamo" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                {t.nav.about}
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-foreground font-serif text-lg mb-4">{t.footer.contact}</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin size={16} className="text-primary" />
                <span>Europa</span>
              </div>
              <a
                href="mailto:giacomo@artisanpizzatalent.com"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
              >
                <Mail size={16} className="text-primary" />
                <span>giacomo@artisanpizzatalent.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-primary/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Artisan Pizza Talent. {t.footer.rights}
            </p>
            <p className="text-xs text-muted-foreground">
              Artisan Pizza Talent - En cours d'immatriculation à Strasbourg
            </p>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
              {t.footer.privacy}
            </Link>
            <Link to="/termini-servizio" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
              {t.footer.terms}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
